// extracted by mini-css-extract-plugin
module.exports = {"image":"LoadingScreen_image__6xyxZ","content":"LoadingScreen_content__h2vmZ","text":"LoadingScreen_text__LyrUT","spinner":"LoadingScreen_spinner__ImQk_"};